export const CONTACT_EMAIL_PATTERN = new RegExp("^(?=.{1,254}$)(?=[^@]{1,64}@)[A-Za-z0-9!#$%&'*+/=?^_\\x60{|}~-]+(?:\\.[A-Za-z0-9!#$%&'*+/=?^_\\x60{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\\.)+[A-Za-z](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])$");
export const CONTACT_PHONE_PATTERN = new RegExp("^(?=(?:[+ -]*[0-9]){7,15}[ -]*$)(?:010-?[0-9]{4}-?[0-9]{4}|02-?[0-9]{3,4}-?[0-9]{4}|0(?:31|32|33|41|42|43|44|51|52|53|54|55|61|62|63|64)-?[0-9]{3,4}-?[0-9]{4}|070-?[0-9]{4}-?[0-9]{4}|080-?[0-9]{3}-?[0-9]{4}|050[2-8]-?[0-9]{4}-?[0-9]{4}|1[0-9]{3}-?[0-9]{4}|\\+[1-9][0-9]*(?:[ -][0-9]+)*)$");

const text = (value: unknown): string => value == null ? '' : String(value).trim();
export function isEmailValid(value: unknown): boolean {
    return CONTACT_EMAIL_PATTERN.test(text(value));
}
export function normalizeMobile(value: unknown): string | null {
    const current = text(value);
    if (!current) return '';
    if (!/^(?:010[0-9]{8}|010-[0-9]{4}-[0-9]{4})$/.test(current)) return null;
    const digits = current.replace(/-/g, '');
    return digits.slice(0, 3) + '-' + digits.slice(3, 7) + '-' + digits.slice(7);
}
function domestic(digits: string): string {
    let prefix = 3;
    let middle = digits.length <= 10 ? 3 : 4;
    if (digits.startsWith('010') || digits.startsWith('070')) middle = 4;
    if (digits.startsWith('02')) { prefix = 2; middle = digits.length <= 9 ? 3 : 4; }
    if (digits.startsWith('050')) { prefix = 4; middle = 4; }
    if (digits.startsWith('1')) { prefix = 4; middle = 4; }
    if (digits.length <= prefix) return digits;
    if (digits.length <= prefix + middle) return digits.slice(0, prefix) + '-' + digits.slice(prefix);
    return digits.slice(0, prefix) + '-' + digits.slice(prefix, prefix + middle) + '-' + digits.slice(prefix + middle);
}
export function normalizePhone(value: unknown): string | null {
    const current = text(value);
    if (!current) return '';
    if (!CONTACT_PHONE_PATTERN.test(current)) return null;
    if (current.startsWith('+')) return '+' + current.replace(/[^0-9]/g, '');
    return domestic(current.replace(/-/g, ''));
}
export function formatPhoneInput(value: string, mobile = false): string {
    if (!/^[0-9-]*$/.test(value)) return value;
    const digits = value.replace(/-/g, '');
    if (digits.length > (mobile ? 11 : 12)) return value;
    if (mobile) {
        if (digits.length <= 3) return digits;
        if (digits.length <= 7) return digits.slice(0, 3) + '-' + digits.slice(3);
        return digits.slice(0, 3) + '-' + digits.slice(3, 7) + '-' + digits.slice(7);
    }
    return domestic(digits);
}

export function normalizeWebsite(value: unknown): string | null {
    if (typeof value !== 'string') return null;
    const raw = value.trim();
    if (!raw) return '';
    if (raw.length > 2048 || /[\s\u0000-\u001f\u007f]/.test(raw)) return null;
    try {
        const url = new URL(raw.includes('://') ? raw : 'https://' + raw);
        if (!['http:', 'https:'].includes(url.protocol) || !url.hostname || url.username || url.password || url.port === '0') return null;
        const host = url.hostname.replace(/\.$/, '');
        if (!host.startsWith('[') && (host.length > 253 || host.split('.').some(label => !/^[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/.test(label)))) return null;
        return url.toString();
    } catch { return null; }
}
